import React, { ChangeEvent, useId } from 'react';

export interface SquareCheckboxProps {
	id?: string;
	name?: string;
	value?: string;
	label: React.ReactNode;
	checked?: boolean;
	defaultChecked?: boolean;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	className?: string;
	ariaLabel?: string;
}

export interface SquareCheckboxGroupProps {
	label: string;
	required?: boolean;
	children: React.ReactNode;
	className?: string;
}

export const SquareCheckbox: React.FC<SquareCheckboxProps> = ({
	id,
	name,
	value,
	label,
	checked,
	defaultChecked,
	onChange,
	disabled,
	className,
	ariaLabel,
}) => {
	const generatedId = useId();
	const inputId = id ?? `square-checkbox-${generatedId}`;

	const rootClassName = ['custom-checkbox-square', className].filter(Boolean).join(' ');

	return (
		<div className={rootClassName}>
			<input
				type="checkbox"
				id={inputId}
				name={name}
				value={value}
				checked={checked}
				defaultChecked={defaultChecked}
				onChange={onChange}
				disabled={disabled}
				aria-label={ariaLabel}
			/>
			<label htmlFor={inputId}>
				<span className="checkbox-icon"></span>
				<span className="icon-square-check"></span>
				{label}
			</label>
		</div>
	);
};

export const SquareCheckboxGroup: React.FC<SquareCheckboxGroupProps> = ({
	label,
	required = false,
	children,
	className,
}) => {
	const wrapperClassName = ['square-checkbox-wrapper', className].filter(Boolean).join(' ');

	return (
		<div className={wrapperClassName}>
			<span className={`chips-radio-label${required ? ' required' : ''}`}>{label}</span>
			<div className="square-checkbox-option">{children}</div>
		</div>
	);
};

export default SquareCheckbox;
